import { Theme, useTheme } from "@amx/ux-twoui-theming";
import { IRawStyle, mergeStyles, mergeStyleSets } from "@fluentui/react";

// These methods are inspired by the upcoming FluentUI v9 mechanism for doing
// styling they call `makeStyle`. They provide a way for us to use a similar API
// that will be coming in FluentUI v9 before upgrading to FluentUI v9
//
// FluentUI v9 makeStyles doc: https://git.io/JzEVE

type MakeStyles = IRawStyle;

export type MakeStylesStyleFunctionRule<Tokens> = (
    tokens: Tokens
) => MakeStyles;
export type MakeStylesStyleRule<Tokens> =
    | MakeStyles
    | MakeStylesStyleFunctionRule<Tokens>;

export function makeStyles<Slots extends string | number>(
    stylesBySlots: Record<Slots, MakeStylesStyleRule<Theme>>
) {
    return function useClasses(): Record<Slots, string> {
        const theme = useTheme();

        const normalizedStylesBySlots: Record<Slots, MakeStyles> = {} as any;
        for (const slot of Object.keys(stylesBySlots)) {
            const styles = stylesBySlots[slot];
            if (typeof styles === "function") {
                normalizedStylesBySlots[slot] = styles(theme);
            } else {
                normalizedStylesBySlots[slot] = styles;
            }
        }

        return mergeStyleSets(normalizedStylesBySlots) as Record<Slots, string>;
    };
}

export function mergeClasses(
    ...classNames: ReadonlyArray<string | false | undefined>
): string {
    return mergeStyles(...classNames);
}
